import { EntryPrefix } from '../../data/model/questionnaire'

export enum Order {
  Randomise = 'Randomise order',
  Reverse = 'Reverse order'
}

// Prefix for the per-item market-visibility annotation the export writes (e.g.
// "Hidden in: 🇩🇪 Germany, 🇫🇷 France"). Shared with the .docx import parser so
// those lines are recognised and skipped on re-import rather than mistaken for
// response options / matrix rows.
export const HIDDEN_MARKETS_PREFIX = 'Hidden in:'

// Printed in the header of a market-specific export (one market x one
// language). Those docs leave out what the market hides, so positions no longer
// line up with the survey: both .docx importers refuse a doc carrying this line.
export const MARKET_EXPORT_MARKER = 'Market-specific export – not for re-import'

// Line prefixes for translatable fields that are not response options. Shared
// with the .docx import parser and the translations extractor so the document
// and the translation keys cannot drift apart.
//
// Slider endpoints, keyed by scale position: 0 left, 1 central, 2 right.
export const SCALE_LABEL_NAMES: Record<number, string | undefined> = {
  0: 'Left-hand label',
  1: 'Central label',
  2: 'Right-hand label'
}

export const MAXDIFF_LABEL_NAMES = {
  mostLabel: 'Most-preferred label',
  leastLabel: 'Least-preferred label',
  attributeLabel: 'Attribute label'
} as const

// e.g. "Attribute 1: Brand" followed by "Level 1: Acme".
export const CONJOINT_ATTRIBUTE_PREFIX = 'Attribute'
export const CONJOINT_LEVEL_PREFIX = 'Level'

// Question-type labels on the header line, matched by the parser.
export const QUESTION_TYPE_MAXDIFF = 'MaxDiff'
export const QUESTION_TYPE_CONJOINT = 'Conjoint'

// Shared so the importer can tell a card's body from a media line in the same
// position.
export const MEDIA_IMAGE_LABEL = 'Question image:'
export const MEDIA_VIDEO_PREFIX = 'Video URL: '

export type QuestionPrefix =
  | `${EntryPrefix.QuestionnaireKind}${number}`
  | `${EntryPrefix.AudienceKind}${number}`
  | `${EntryPrefix.TextCardEntryType}${number}`
  | `${EntryPrefix.SectionEntryType}${number}`
